import type { Component } from 'vue';
import type { CollectionFieldPath } from '#layers/data-model/public';
import type { FilterAction } from '#layers/filters/public';
import { createContext } from 'reka-ui';

/** Filter actions a listing offers its layouts, each with the gate check for the filter it adds. */
export interface ListingFieldFilters {
	add: (action: FilterAction) => void;
	resolve: (fieldPath: CollectionFieldPath) => FilterAction | undefined;
	resolveWithValue: (fieldPath: CollectionFieldPath, value: unknown) => FilterAction | undefined;
}

interface ListingContext {
	setDisplayOptionsComponent: (component: Component | null) => void;
	fieldFilters?: ListingFieldFilters;
}

export const [injectListingContext, provideListingContext] = createContext<ListingContext>('Listing');
